import { usePrivy } from "@privy-io/react-auth";
import { useAuth } from "contexts/authContext";
import { PRIVY_TOKEN, getItem } from "local-storage";
import { useEffect } from "react";
import { ReactComponent as Icon } from "assets/images/icon.svg";
import { ReactComponent as WrongBrower } from "assets/icons/wrongBrower.svg";

import {
  isAndroid,
  isChrome,
  isSafari,
  isBrowser,
  isIOS,
} from "react-device-detect";
import axios from "axios";
import { getAuthUrl } from "services/apis/urls";
import { LandingPage } from "components/commons/LandingPage";
import slugs from "navigation/slugs";
import { useNavigate } from "react-router-dom";

function Login() {
  const { updateToken, updateReferrerId } = useAuth();
  const { ready, authenticated, login } = usePrivy();
  const navigate = useNavigate();

  useEffect(() => {
    const f = async () => {
      try {
        console.log(
          "🚀 ~ file: Login.tsx:30 ~ f ~ data:",
          ready,
          authenticated
        );

        if (ready && authenticated) {
          // Get privy access token
          const privyToken = getItem(PRIVY_TOKEN);
          console.log("🚀 ~ file: Login.tsx:38 ~ f ~ data:", privyToken);
          // Post privy access token to get server access token
          const authenticateState = await axios.post(
            `${getAuthUrl}/login/authenticate-status`,
            {
              token: JSON.parse(privyToken!),
            },
            { headers: { "Content-Type": "application/json" } }
          );

          if (authenticateState?.data?.data === "USER_IS_NOT_LINKED_TW") {
            navigate(slugs.accountVerify, { replace: true });
          } else if (authenticateState?.data?.data === "USER_IS_LINKED_TW") {
            const res = await axios.post(
              `${getAuthUrl}/login`,
              {
                token: JSON.parse(privyToken!),
              },
              { headers: { "Content-Type": "application/json" } }
            );
            console.log("🚀 ~ file: Login.tsx:58 ~ f ~ res:", res);

            if (res?.data?.data?.referrer_id) {
              updateToken(res?.data?.data?.access_token);
              updateReferrerId(res.data.data.referrer_id);
            } else {
              updateToken(res?.data?.data?.access_token);
            }
          } else {
            return;
          }
        }
      } catch (error) {
        console.log("🚀 ~ file: Login.tsx:41 ~ f ~ error:", error);
      }
    };
    f();
  }, [authenticated, ready]);

  const handleLogin = async () => {
    try {
      login();
    } catch (error) {
      console.error("An error occurred", error);
    }
  };

  const isInStandaloneMode = window.matchMedia(
    "(display-mode: standalone)"
  ).matches;

  return (
    <div className="min-h-screen flex-1 flex flex-col h-full w-full justify-center items-center">
      {!isInStandaloneMode && isBrowser ? <LandingPage /> : null}

      {(!isInStandaloneMode && isAndroid && isChrome) ||
      (!isInStandaloneMode && isIOS && isSafari) ? (
        <LandingPage />
      ) : null}

      {(!isInStandaloneMode && isAndroid && !isChrome) ||
      (!isInStandaloneMode && isIOS && !isSafari) ? (
        <div className="z-50 text-center flex flex-col bg-white p-10 m-6 rounded-xl gap-4 shadow justify-center items-center text-sm font-normal text-gray-700">
          <WrongBrower className="w-32" />
          <span className=" text-lg text-gray-900">Wrong browser detected</span>
          <span className="">
            Please open fan.tech on {isIOS ? "Safari" : "Chrome"} to install
            this app.
          </span>
        </div>
      ) : null}

      {isInStandaloneMode ? (
        <div className="z-50 flex flex-col h-full w-full justify-center items-center">
          <Icon className="w-16" />

          <div className="text-2xl font-bold text-slate-300 altsans">
            Fan Service, Redefined
          </div>

          <button
            className="btn w-40 font-medium bg-[#40F8FF] mt-24 text-cyan-900 rounded-full"
            onClick={(e) => {
              e.preventDefault();
              handleLogin();
            }}
          >
            Sign in
          </button>
        </div>
      ) : null}
    </div>
  );
}
export default Login;
